export const MARKETSTORE_SEARCH_ATTEMPT = "MARKETSTORE_SEARCH_ATTEMPT";
export const MARKETSTORE_SEARCH_SUCCESS = "MARKETSTORE_SEARCH_SUCCESS";
export const MARKETSTORE_SEARCH_FAILED = "MARKETSTORE_SEARCH_FAILED";
export const LOGOUT = "LOGOUT";